export default __webpack_public_path__ + "static/media/people5small.ca30e53b.jpg";